// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"03ca8e17","715":"de207bf5"}[chunkId] + ".chunk.js";
};